import React from 'react';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <Instagram size={20} />, label: 'Instagram', url: 'https://www.instagram.com/classicdecor_38' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0a0a0c] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3
              className="text-2xl font-serif text-[#FF8C42] mb-4"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Classic Decor
            </h3>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Finest Craft in Town
            </p>
            <p className="text-white/50 text-sm">
              Transforming spaces with excellence since 2004
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-medium mb-6">Quick Links</h4>
            <div className="space-y-3">
              {['Home', 'Services', 'Portfolio', 'About', 'Team', 'Contact'].map((link) => (
                <button
                  key={link}
                  onClick={() => scrollToSection(link.toLowerCase())}
                  className="block text-white/60 hover:text-[#FF8C42] transition-colors text-sm"
                >
                  {link}
                </button>
              ))}
            </div>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="text-white font-medium mb-6">Connect With Us</h4>
            <div className="space-y-3 mb-6">
              <a
                href="tel:+919902199065"
                className="block text-white/60 hover:text-[#FF8C42] transition-colors text-sm"
              >
                +91 99021 99065
              </a>
              <a
                href="mailto:classic.decor24@gmail.com"
                className="block text-white/60 hover:text-[#FF8C42] transition-colors text-sm"
              >
                classic.decor24@gmail.com
              </a>
            </div>

            {/* Social Links */}
            <div className="flex gap-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#FF8C42] text-white/60 hover:text-white flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} Classic Decor. All rights reserved.
          </p>
          <p className="text-white/30 text-xs">
            Crafted with excellence in Bangalore
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;